import type { SgCalendarEvent, SgCalendarEventKind } from './types';

export const KIND_LABEL: Record<SgCalendarEventKind, string> = {
  legal_expiry: 'Vencimiento legal',
  legal_evaluation_due: 'Reevaluación legal',
  objective_due: 'Objetivo / tarea',
  indicator_missing: 'Medición de indicador',
  training_reminder: 'Capacitación',
  audit_due: 'Auditoría',
  risk_action_overdue: 'Vencimiento acción de riesgo',
  management_review_due: 'Revisión por la dirección',
  calibration_due: 'Calibración',
  supplier_evaluation_due: 'Evaluación de proveedor',
  supplier_reevaluation: 'Reevaluación de proveedor',
  drill_due: 'Simulacro de emergencia',
};

export const KIND_BADGE_CLASS: Record<SgCalendarEventKind, string> = {
  legal_expiry: 'bg-rose-100 text-rose-800',
  legal_evaluation_due: 'bg-orange-100 text-orange-800',
  objective_due: 'bg-sky-100 text-sky-800',
  indicator_missing: 'bg-amber-100 text-amber-800',
  training_reminder: 'bg-violet-100 text-violet-800',
  audit_due: 'bg-indigo-100 text-indigo-800',
  risk_action_overdue: 'bg-red-100 text-red-800',
  management_review_due: 'bg-emerald-100 text-emerald-800',
  calibration_due: 'bg-teal-100 text-teal-800',
  supplier_evaluation_due: 'bg-lime-100 text-lime-800',
  supplier_reevaluation: 'bg-lime-100 text-lime-800',
  drill_due: 'bg-orange-100 text-orange-800',
};

export function buildEventPath(event: SgCalendarEvent): string {
  switch (event.kind) {
    case 'legal_expiry':
    case 'legal_evaluation_due':
      return `/requisitos-legales/${event.refId}`;
    case 'objective_due':
      return `/objetivos/${event.refId}`;
    case 'indicator_missing':
      return '/objetivos';
    case 'training_reminder':
      return '/competencias';
    case 'audit_due':
      return `/auditorias/${event.refId}`;
    case 'risk_action_overdue':
      return `/riesgos/${event.refId}`;
    case 'management_review_due':
      return `/revision-direccion/${event.refId}`;
    case 'calibration_due':
      return event.refId ? `/mantenimiento/equipos/${event.refId}` : '/mantenimiento/equipos';
    case 'supplier_evaluation_due':
    case 'supplier_reevaluation':
      return `/proveedores/${event.refId}`;
    case 'drill_due':
      return '/emergencias?tab=upcoming';
    default:
      return '/';
  }
}

export function toDateKey(iso: string): string {
  return iso.slice(0, 10);
}

export function formatEventDate(iso: string): string {
  return new Date(iso).toLocaleDateString('es-AR', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function monthRange(year: number, month: number): { from: string; to: string } {
  const from = new Date(year, month, 1);
  const to = new Date(year, month + 1, 0, 23, 59, 59, 999);
  return { from: from.toISOString(), to: to.toISOString() };
}

export function buildMonthGrid(year: number, month: number): Array<Date | null> {
  const firstDay = new Date(year, month, 1);
  const startWeekday = firstDay.getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells: Array<Date | null> = [];

  for (let i = 0; i < startWeekday; i += 1) {
    cells.push(null);
  }
  for (let day = 1; day <= daysInMonth; day += 1) {
    cells.push(new Date(year, month, day));
  }
  return cells;
}
